import Control from 'ol/control/Control.js';
import {assign} from 'ol/obj.js';
import {appendParams} from 'ol/uri.js';
import {DEFAULT_WMS_VERSION} from 'ol/source/common.js';

class LegendControl extends Control {
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};

    const button = document.createElement('button');
    button.addEventListener('click', () => {
      this.setActive(!this.active);
    });

    const element = document.createElement('div');
    element.className = 'legend-overlaycontainer';

    const control = document.createElement('div');
    control.className = 'legend-control ol-unselectable ol-control';
    control.title = 'Afficher la légende de la carte';
    control.appendChild(button);

    element.appendChild(control);

    super({
      element: element,
      target: options.target,
    });

    this.button = button;
    this.className = 'toggle fas fa-list';

    this.container = this.createOverlayDomTree_();
    element.appendChild(this.container);

    this.setActive(options.active || false);
  }

  setActive(active) {
    this.button.className = this.className + (active ? ' active' : '');
    this.active = active;
    if (active) {
      this.container.className = 'ol-popup legend collapse in';
    } else {
      this.container.className = 'ol-popup legend collapse';
    }
  }

  /**
   * @private
   * @return {HTMLElement} overlay container element.
   */
  createOverlayDomTree_() {
    const overlayContainer = document.createElement('div');
    overlayContainer.className = 'ol-popup legend collapse';
    const overlayCloser = document.createElement('div');
    overlayCloser.className = 'ol-popup-closer';
    overlayCloser.addEventListener('click', () => {
      this.setActive(false);
      return false;
    });
    const overlayContent = document.createElement('div');
    overlayContent.className = 'ol-popup-content';

    overlayContainer.appendChild(overlayCloser);
    overlayContainer.appendChild(overlayContent);

    return overlayContainer;
  }

  setLayers(layers) {
    const content = this.container.querySelector('.ol-popup-content');
    content.innerHTML = '';
    for (const layer of layers.reverse()) {
      const legendUrl = this.getLegendUrl(layer.getSource(), this.getMap().getView().getResolution(), {
        VERSION: '1.1.1',
        TRANSPARENT: 'true',
      });
      const element = document.createElement('div');
      const img = document.createElement('img');
      img.src = legendUrl;
      element.appendChild(img);
      content.appendChild(element);
    }
  }

  /* Available in ol 6 as ImageWMS.getLegendUrl */
  getLegendUrl(source, resolution, params) {
    if (source.url_ === undefined) {
      return undefined;
    }

    const baseParams = {
      'SERVICE': 'WMS',
      'VERSION': DEFAULT_WMS_VERSION,
      'REQUEST': 'GetLegendGraphic',
      'FORMAT': 'image/png',
    };

    if (params === undefined || params['LAYER'] === undefined) {
      const layers = source.params_.LAYERS;
      const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
      if (!isSingleLayer) {
        return undefined;
      }
      baseParams['LAYER'] = layers;
    }

    if (resolution !== undefined) {
      const mpu = source.getProjection() ? source.getProjection().getMetersPerUnit() : 1;
      const dpi = 25.4 / 0.28;
      const inchesPerMeter = 39.37;
      baseParams['SCALE'] = resolution * mpu * inchesPerMeter * dpi;
    }

    assign(baseParams, params);

    return appendParams(/** @type {string} */ (source.url_), baseParams);
  }
}

export default LegendControl;
